import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../components/Breadcrumb";
import { DASHBOARD, SOCIETY_BRAND, SOCIETY_CONTROLLER } from "../../../Routing/routes";
import FormValidationLayer from "./Component/FormValidationLayer";

const EditBrand = () => {
    const { id } = useParams();

    const links = [
        { to: SOCIETY_BRAND, text: 'Community Brand' },
        { to: `${SOCIETY_BRAND}/${id}/edit`, text: 'Edit' }
    ];

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                links={links}
                headingTitle="Edit Community Brand"
                title="CRM"
                to={SOCIETY_CONTROLLER + DASHBOARD}
            />
            <FormValidationLayer isEditMode={true} brandId={id} />
        </>
    );
};

export default EditBrand;
